import { useState, useEffect } from 'react';

interface RegimeBreakBannerProps {
  message: string;
  seriesId: string;
}

const STORAGE_KEY_PREFIX = 'regime_break_dismissed_';

export function RegimeBreakBanner({ message, seriesId }: RegimeBreakBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const key = STORAGE_KEY_PREFIX + seriesId;
    setDismissed(sessionStorage.getItem(key) === '1');
  }, [seriesId]);

  if (dismissed || !message) return null;

  const handleDismiss = () => {
    const key = STORAGE_KEY_PREFIX + seriesId;
    sessionStorage.setItem(key, '1');
    setDismissed(true);
  };

  return (
    <div className="flex items-start gap-2 px-3 py-2 rounded-lg border border-amber-500/30 bg-amber-500/10 text-amber-400 text-xs">
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="shrink-0 mt-0.5"
      >
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <span className="flex-1 leading-relaxed">{message}</span>
      <button
        onClick={handleDismiss}
        className="shrink-0 p-0.5 rounded hover:bg-amber-500/20 transition-colors"
        aria-label="Dismiss"
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
}
